// Import Lunr.js
import lunr from 'lunr';

// Import articles and stories
import exploreArticles from '@/content/explore/articles.js';
import cultureArticles from '@/content/culture/articles.js';
import stories from '@/content/stories/articles.js';

// Combine articles and stories into a single array
const allDocuments = [
  ...exploreArticles.map((article) => ({
    id: `explore-${article.id}`, // Ensure unique IDs
    title: article.title,
    summary: article.summary,
    content: article.content, // Include content if available
    section: 'explore',
  })),
  ...cultureArticles.map((article) => ({
    id: `culture-${article.id}`,
    title: article.title,
    summary: article.summary,
    content: article.content,
    section: 'culture',
  })),
  ...stories.map((story) => ({
    id: `stories-${story.id}`,
    title: story.title,
    summary: story.summary,
    content: story.content,
    section: 'stories',
  })),
];

// Build the Lunr index
const idx = lunr(function () {
  // Define fields to index
  this.ref('id'); // Document reference field
  this.field('title', { boost: 10 }); // Boost title field
  this.field('summary', { boost: 5 }); // Boost summary field
  this.field('content'); // Include content if available

  // Add documents to the index
  allDocuments.forEach((doc) => {
    this.add(doc);
  });
});

// Export the index and documents
export { idx, allDocuments };